import $ from 'jquery'
import 'slick-carousel'
import $clamp from 'clamp-js'

export default class HeroSliderController {
  constructor (element) {
    this._element = element
    this._initClamp()
    this._initSlider()
  }

  _updateClasses (sliderElement, currentSlide, slick) {
    console.log(currentSlide)
    $(sliderElement).find('.slick-previous').removeClass('slick-previous')
    const $currentSlide = $(slick.$slides[currentSlide])
    const $previousSlide = $currentSlide.prev()
    const previousSlideIndex = $previousSlide.find('.hero-slider__item').attr('data-hero-slider-index')
    const $previousSlideElements = $(sliderElement).find(`[data-hero-slider-index="${previousSlideIndex}"]`).closest('.slick-slide')
    $previousSlideElements.addClass('slick-previous')
  }

  _initClamp () {
    try {
      const blurbElements = this._element.querySelectorAll('.hero-slider__item__blurb')
      ;[].forEach.call(blurbElements, element => {
        $clamp(element, { clamp: 3 })
      })
    } catch (exception) {
      // Don't want this to break our slider
    }
  }

  _initSlider () {
    const sliderElement = this._element.querySelector('.hero-slider__list')
    if (sliderElement) {
      const $sliderElement = $(sliderElement)

      $sliderElement.slick({
        slidesToShow: 1,
        // speed: 10000,
        // autoplay: true,
        // autoplaySpeed: 0,
        // pauseOnFocus: false,
        // pauseOnHover: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1250,
        mobileFirst: true,
        prevArrow: '.hero-slider__previous-button', // '.' + previousButtonClass,
        nextArrow: '.hero-slider__next-button', // '.' + nextButtonClass,
        variableWidth: true,
        centerMode: false,
        pauseOnHover: false,
        swipeToSlide: true,
        waitForAnimate: true
      })
      this._updateClasses(sliderElement, $sliderElement.slick('slickCurrentSlide'), $sliderElement.slick('getSlick'))

      $sliderElement.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
        $sliderElement.addClass('slick-custom-transition-ready')
        this._updateClasses(sliderElement, nextSlide, slick)
      })
      $sliderElement.on('afterChange', (event, slick, currentSlide) => {
        this._updateClasses(sliderElement, currentSlide, slick)
      })

      const slideCounterElement = this._element.querySelector('.hero-slider__slide-number')
      if (slideCounterElement) {
        const updateCount = (current, total) => {
          const text = current + '/' + total
          slideCounterElement.innerText = text
        }

        const slick = $sliderElement.slick('getSlick')
        const totalSlides = slick.slideCount
        const current = slick.currentSlide
        updateCount(current + 1, totalSlides)
        $sliderElement.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
          updateCount(nextSlide + 1, slick.slideCount)
          // const text = currentSlide.
          // slideCounterElement.innerText =
        })
      }
    }
  }
}
